import { Button, Flex, Heading, Markdown, Modal, Paragraph } from "@ir/ui";

interface MasterDataHelpTextPreviewModalProps {
  isOpen: boolean;
  title: string;
  content: string;
  onClose: () => void;
}

const HELP_TEXT_PREVIEW_Z_INDEX = 4;

/** Read-only modal for Master Data markdown help text. */
export const MasterDataHelpTextPreviewModal = ({
  isOpen,
  title,
  content,
  onClose,
}: Readonly<MasterDataHelpTextPreviewModalProps>) => {
  const trimmed = content.trim();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closable
      size="large"
      zIndex={HELP_TEXT_PREVIEW_Z_INDEX}
      classNames={{
        body: "master-data-help-text-preview-modal__body",
      }}
      headerContent={
        <Heading level={6} className="text-grey-700 font-bold m-0">
          {title}
        </Heading>
      }
      footerContent={
        <Flex justifyContent="end">
          <Button size="small" color="grey" onPress={onClose}>
            Close
          </Button>
        </Flex>
      }
    >
      {trimmed ? (
        <Markdown
          content={content}
          className="master-data-help-text-markdown master-data-help-text-preview-modal__content"
        />
      ) : (
        <Paragraph className="text-grey-500 m-0">No content</Paragraph>
      )}
    </Modal>
  );
};
